import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

export const STATUS_BANNER_HEIGHT = 40;
export const CHEVRON_PADDING = 7;
export const BannerWrapper = styled(Box).attrs(
  ({ bgColor = 'primaryBase' }) => ({
    width: '100%',
    borderRadius: '5px',
    align: 'center',
    bg: bgColor,
    height: STATUS_BANNER_HEIGHT,
    py: '12px',
    px: '20px',
  }),
)`
  height: max-content;
  position: relative;
`;

export const TextIconWrapper = styled(Box).attrs({
  align: 'center',
  justify: 'flex-start',
})``;
export const BannerText = styled(Text).attrs({
  color: 'background',
  ml: '12px',
  size: 'normal',
})``;
export const IconWrapper = styled(Box).attrs({
  color: 'background',
})``;
export const IconWrapperChevron = styled(IconWrapper).attrs({
  borderRadius: '5px',
  mr: '20px',
  border: '1px solid',
  borderColor: 'lightLineDivider',
  p: `${CHEVRON_PADDING}px`,
})`
  position: absolute;
  right: 0;
  cursor: pointer;
`;
